<template>
  <div class="app-container">
    <PageTitle title="拼团派单" ref="pageTitle" v-model="listQuery.city" @onChange="changeCity" />
    <h4>步骤一：筛选拼团订单</h4>
    <div class="filter-container">
      <el-date-picker
        v-model="listQuery.use_date"
        type="date"
        placeholder="选择日期"
        value-format="yyyy-MM-dd"
        style="margin: 0 10px 10px 0; vertical-align: middle; width: 160px"
        @change="handleUseDate"
      ></el-date-picker>
      <TimeSelect @changeInterval="handleInterval" v-model="listQuery.interval_time" />
      <el-select
        clearable
        v-model="listQuery.project_name"
        filterable
        placeholder="请选择项目名称"
        style="width: 160px; margin-right: 10px"
        @change="changeProject"
      >
        <el-option
          v-for="item in project_options"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>
      <el-input
        clearable
        style="width: 160px"
        class="filter-item"
        placeholder="联系人手机号"
        v-model="listQuery.contact_mobile"
        @change="handleContactMobile"
      ></el-input>
      <el-input
        clearable
        style="width: 160px"
        class="filter-item"
        placeholder="联系人姓名"
        v-model="listQuery.contact_name"
        @change="handleContactName"
      ></el-input>
      <el-input
        clearable
        style="width: 160px"
        class="filter-item"
        placeholder="请输入订单编号"
        v-model="listQuery.ota_sn"
        @change="handleOtaSn"
      ></el-input>

      <el-button
        class="filter-item"
        type="primary"
        plain
        icon="el-icon-refresh-left"
        @click="handleReset"
        >重置</el-button
      >
      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter"
        >搜索</el-button
      >
    </div>
    <h4>步骤二：选择待派订单</h4>
    <Table
      ref="mulTable"
      :data="list"
      :columns="columns"
      :loading="listLoading"
      @changeSelect="changeSelect"
      :checkBox="!!listQuery.project_id"
    >
      <template v-slot:selection>
        <el-table-column
          width="50"
          align="center"
          type="selection"
          :selectable="checkSelectable"
          :key="`selection_${selectionVersion}`"
        >
        </el-table-column>
      </template>
      <template v-slot:source>
        <el-table-column label="订单来源" width="140" align="center">
          <template slot-scope="scope">
            {{ $platform[scope.row.source] }}
          </template>
        </el-table-column>
      </template>
      <template v-slot:interval_time>
        <el-table-column label="场次" width="80" align="center">
          <template slot-scope="scope"> {{ scope.row.interval_time }}场 </template>
        </el-table-column>
      </template>
      <template v-slot:contact>
        <el-table-column label="联系人" width="130" align="center">
          <template slot-scope="scope">
            {{ scope.row.contact.name }}｜{{ scope.row.contact.mobile }}
          </template>
        </el-table-column>
      </template>
      <template v-slot:pay_time>
        <el-table-column label="下单时间" width="140" align="center">
          <template slot-scope="scope">
            <el-link type="info" :underline="false">{{ scope.row.pay_time }}</el-link>
          </template>
        </el-table-column>
      </template>

      <template v-slot:assign_status>
        <el-table-column label="派单状态" minWidth="100">
          <template slot-scope="scope">
            {{ ['', '未派单', '已派单'][scope.row.assign_status] }}
          </template>
        </el-table-column>
      </template>
    </Table>
    <div class="footer">
      <div class="total">
        已选择订单数： {{ changeInfo.order_num }}个，总人数：{{ changeInfo.user_num }}
        <br />
        出行日期：{{ displayUseDate }}，场次：{{ displayInterval }}，项目：{{ displayProject }}
        <el-button
          v-if="selectedRows.length > 0"
          type="primary"
          size="mini"
          icon="el-icon-document"
          @click="handleOpenCopy"
          style="margin-left: 10px"
          >复制信息</el-button
        >
      </div>
      <div class="pagination-container">
        <pagination
          :total="count"
          :page.sync="listQuery.page"
          :limit.sync="listQuery.size"
          @pagination="fetchData"
        />
      </div>
    </div>
    <div class="guide-search" v-if="orders.length > 0">
      <h4>步骤三：选择导游</h4>
      <el-input
        v-model="searchGuideName"
        clearable
        style="width: 200px; margin-left: 12px"
        placeholder="导游姓名"
      ></el-input>
    </div>
    <GuidesTable
      :orders="orders"
      :trip_type="1"
      :keyword="searchGuideName"
      v-if="orders.length > 0"
    />
    <CopyInfoDialog ref="copyInfoDialog" />
  </div>
</template>

<script>
import { getList } from '@/api/orders'
import { getList as getProjectList } from '@/api/projects'
import PageTitle from '@/components/PageTitle'
import GuidesTable from '@/components/GuidesTable'
import TimeSelect from '@/components/TimeSelect'
import CopyInfoDialog from './components/CopyInfoDialog'
export default {
  name: 'AssignGroup',
  components: {
    PageTitle,
    GuidesTable,
    TimeSelect,
    CopyInfoDialog
  },
  data() {
    return {
      list: null,
      count: 0,
      listLoading: true,
      prickerOptions: {
        start: '00:00',
        step: '00:30',
        end: '18:30',
        format: 'HH:mm',
        selectableRange: ['00:00', '08:30:00-18:30:00']
      },
      listQuery: {
        page: 1,
        size: 10,
        city: '',
        is_assign_guide: 1,
        trip_type: 1,
        assign_status: 1,
        ota_sn: '',
        project_id: '',
        project_name: '',
        contact_mobile: '',
        contact_name: '',
        use_date: '',
        interval_time: ''
      },
      project_item: {},

      columns: [
        { type: 'selection', slot: 'selection' },
        {
          label: '订单编号',
          width: '150',
          prop: 'ota_sn'
        },
        {
          label: '产品名称',
          width: '200',
          prop: 'product_name',
          showOverflowTooltip: true
        },
        {
          label: '套餐名称',
          width: '100',
          prop: 'package_name',
          showOverflowTooltip: true
        },
        {
          label: '订单来源',
          slot: 'source'
        },
        {
          label: '数量',
          width: '60',
          prop: 'user_num',
          align: 'center'
        },
        {
          label: '出发日期',
          width: '100',
          prop: 'use_date',
          align: 'center'
        },
        {
          label: '场次',
          slot: 'interval_time'
        },
        {
          label: '项目',
          width: '120',
          prop: 'project_name',
          showOverflowTooltip: true
        },
        {
          label: '联系人',
          slot: 'contact'
        },
        {
          label: '下单时间',
          slot: 'pay_time'
        },
        {
          label: '派单状态',
          slot: 'assign_status'
        }
      ],
      changeInfo: {
        order_num: 0,
        user_num: 0
      },
      orders: [],
      selectedRows: [],
      selectedRowMap: {},
      project_options: [],
      user_limit: 0,
      timeOptions: ['00:00', '08:30'],
      selectionVersion: 0,
      searchGuideName: '',
      isRestoring: false
    }
  },
  created() {
    this.fetchData()
    getProjectList({ size: 1000 }).then((res) => {
      this.project_options = res.data.results
    })
  },
  mounted() {
    this.listQuery.city = this.$refs.pageTitle.city
  },
  computed: {
    displayUseDate() {
      return this.selectedRows && this.selectedRows.length > 0
        ? this.selectedRows[0].use_date
        : this.listQuery.use_date
    },
    displayInterval() {
      return this.selectedRows && this.selectedRows.length > 0
        ? this.selectedRows[0].interval_time
        : this.listQuery.interval_time
    },
    displayProject() {
      return this.selectedRows && this.selectedRows.length > 0
        ? this.selectedRows[0].project_name
        : this.listQuery.project_name
    }
  },
  methods: {
    // 获取数据
    fetchData() {
      this.listLoading = true
      const query = { ...this.listQuery }
      this.isRestoring = true
      getList(query)
        .then((res) => {
          this.list = res.data.results
          this.count = res.data.count
          this.listLoading = false
          this.$nextTick(() => {
            this.restoreSelection()
            setTimeout(() => {
              this.isRestoring = false
            }, 0)
          })
        })
        .catch(() => {
          this.isRestoring = false
          this.listLoading = false
        })
    },
    /**
     * @description: 选择城市
     * @param {*} e
     * @return {*}
     */
    changeCity(e) {
      this.listQuery.city = e
      this.clearSelections()
      this.handleFilter()
    },
    // 筛选
    handleFilter() {
      this.clearSelections()
      this.listQuery.page = 1
      this.fetchData()
    },
    handleUseDate(e) {
      this.listQuery.use_date = e
      this.clearSelections()
      this.handleFilter()
    },
    handleInterval(e) {
      this.listQuery.interval_time = e
      this.clearSelections()
      this.handleFilter()
    },
    /**
     * @description: 重置
     * @return {*}
     */
    handleReset() {
      this.listQuery = {
        page: 1,
        size: 10,
        city: 1,
        is_assign_guide: 1,
        trip_type: 1,
        assign_status: 1,
        ota_sn: '',
        project_id: '',
        project_name: '',
        contact_mobile: '',
        contact_name: '',
        use_date: '',
        interval_time: ''
      }
      this.clearSelections()
      this.fetchData()
    },
    /**
     * @description: 多选
     * @param {*} e
     * @return {*}
     */
    restoreSelection() {
      const mulTableRef = this.$refs.mulTable
      if (!mulTableRef || !mulTableRef.$refs || !mulTableRef.$refs.tableRef) return
      const tableRef = mulTableRef.$refs.tableRef
      if (!Array.isArray(this.list) || this.list.length === 0) return
      this.list.forEach((row) => {
        if (this.orders.includes(row.sn)) {
          tableRef.toggleRowSelection(row, true)
        }
      })
    },
    changeSelect(values) {
      if (this.isRestoring) return
      const _this = this
      const pageAllKeys = Array.isArray(_this.list) ? _this.list.map((r) => r.sn) : []
      const pageSelKeys = values.map((r) => r.sn)
      // 移除当前页未选中的 keys
      if (Array.isArray(_this.orders) && _this.orders.length > 0) {
        _this.orders = _this.orders.filter(
          (k) => !(pageAllKeys.includes(k) && !pageSelKeys.includes(k))
        )
      } else {
        _this.orders = []
      }
      // 增加当前页新选中的 keys
      pageSelKeys.forEach((k) => {
        if (!_this.orders.includes(k)) _this.orders.push(k)
      })
      // 同步 selectedRowMap：当前页已选写入/更新；当前页未选删除
      pageAllKeys.forEach((k) => {
        if (!pageSelKeys.includes(k)) {
          delete _this.selectedRowMap[k]
        }
      })
      values.forEach((row) => {
        _this.selectedRowMap[row.sn] = row
      })
      // 生成全局 selectedRows
      _this.selectedRows = _this.orders.map((k) => _this.selectedRowMap[k]).filter(Boolean)
      // 统计信息
      _this.changeInfo.order_num = _this.selectedRows.length
      const arr = _this.selectedRows.map((item) => item.user_num)
      _this.changeInfo.user_num = arr.length > 0 ? arr.reduce((p, c) => p + c, 0) : 0

      // 如果未选择项目时直接勾选了数据，获取对应项目的最大人数限制
      if (!_this.listQuery.project_id && values.length > 0) {
        let matchedProject = _this.project_options.find((p) => p.name === values[0].project_name)
        if (matchedProject) {
          _this.user_limit = matchedProject.user_limit
        }
      }

      // 如果未选择项目，且取消了所有勾选，将限制重置
      if (!_this.listQuery.project_id && values.length === 0) {
        _this.user_limit = 0
      }

      // 如果已经取消了最后一个选中项，强制刷新选择列以恢复所有行可选
      if (_this.selectedRows.length === 0) {
        _this.selectionVersion++
      }

      // 选择超过人数限制
      if (_this.user_limit > 0 && _this.changeInfo.user_num > _this.user_limit) {
        _this.$message.error(`每组拼团，最多可选${_this.user_limit}人哦～`)
        const laseItem = values[values.length - 1]
        if (laseItem) {
          // 从全局移除
          const key = laseItem.sn
          _this.orders = _this.orders.filter((k) => k !== key)
          delete _this.selectedRowMap[key]
          _this.selectedRows = _this.orders.map((k) => _this.selectedRowMap[k]).filter(Boolean)
          _this.changeInfo.order_num = _this.selectedRows.length
          const arr2 = _this.selectedRows.map((item) => item.user_num)
          _this.changeInfo.user_num = arr2.length > 0 ? arr2.reduce((p, c) => p + c, 0) : 0
          // UI 取消当前页最后一次勾选
          const mulTableRef = _this.$refs.mulTable
          if (mulTableRef && mulTableRef.$refs && mulTableRef.$refs.tableRef) {
            _this.isRestoring = true
            mulTableRef.$refs.tableRef.toggleRowSelection(laseItem, false)
            setTimeout(() => {
              _this.isRestoring = false
            }, 0)
          }
        }
      }
    },
    /**
     * @description: 选择项目名称
     * @param {*} e
     * @return {*}
     */
    changeProject(value) {
      if (!value) {
        this.listQuery.project_id = ''
        this.listQuery.project_name = ''
        this.user_limit = 0
        this.clearSelections()
        this.handleFilter()
        return
      }
      let list = this.project_options.filter((item) => item.id === value)
      console.log('list', list, value)

      this.listQuery.project_id = value
      this.listQuery.project_name = list[0] ? list[0].name : ''
      this.user_limit = list[0] ? list[0].user_limit : 0
      this.clearSelections()
      this.handleFilter()
    },
    handleContactMobile(e) {
      this.listQuery.contact_mobile = e
      this.clearSelections()
      this.handleFilter()
    },
    handleContactName(e) {
      this.listQuery.contact_name = e
      this.clearSelections()
      this.handleFilter()
    },
    handleOtaSn(e) {
      this.listQuery.ota_sn = e
      this.clearSelections()
      this.handleFilter()
    },
    clearSelections() {
      this.orders = []
      this.selectedRows = []
      this.selectedRowMap = {}
      this.changeInfo.order_num = 0
      this.changeInfo.user_num = 0
      this.user_limit = 0
      this.searchGuideName = ''
      this.selectionVersion++
      const mulTableRef = this.$refs.mulTable
      if (mulTableRef && mulTableRef.$refs && mulTableRef.$refs.tableRef) {
        mulTableRef.$refs.tableRef.clearSelection()
      }
    },
    /**
     * @description: 判断是否可选
     * @return {*}
     */
    checkSelectable(row) {
      // if (!this.listQuery.project_id) return false
      if (this.selectedRows && this.selectedRows.length > 0) {
        const first = this.selectedRows[0]
        return (
          row.use_date === first.use_date &&
          row.project_name === first.project_name &&
          row.interval_time === first.interval_time
        )
      }
      return true
    },
    handleOpenCopy() {
      const first = this.selectedRows && this.selectedRows.length > 0 ? this.selectedRows[0] : {}
      const payload = {
        orders: this.selectedRows || [],
        project_name: first.project_name || '',
        use_date: first.use_date || this.listQuery.use_date || '',
        trip_type: 1,
        interval_time: first.interval_time || this.listQuery.interval_time || ''
      }
      if (this.$refs.copyInfoDialog) {
        this.$refs.copyInfoDialog.open(payload)
      }
    }
  }
}
</script>
<style scoped>
.footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.filter-container {
  justify-content: flex-start !important;
  flex-wrap: wrap;
}

::v-deep .el-table__header-wrapper .el-checkbox {
  display: none;
}
.guide-search {
  display: flex;
  align-items: center;
  margin-top: 10px;
}
</style>
